<template>
  <div class="view-wrapper">
    <template>
      <div class="search-bar-list pd-btm0">
        <swipeBack
          v-if="showHeaderBar"
          :title="title"
          :backtxt="$t('back')"
          @backFn="backFn"
        />
        <!-- <div style="width: 100%">
          <van-search
            v-model="keyword"
            shape="round"
            background="#ffffff"
            placeholder="输入医院/科室/医生搜索"
            :clearable="false"
            @input="searchDoctor"
          />
        </div> -->
        <div class="search-filter">
          <div class="search-filter-drop" @click="showFilterPopup = true">
            <van-dropdown-menu active-color="#aa341b" style="width: calc(100% - 10px)">
              <van-dropdown-item disabled :title="$t('filter') + filterPrompt"></van-dropdown-item>
            </van-dropdown-menu>
            <van-dropdown-menu v-if="false" active-color="#aa341b" style="width: 100%">
              <van-dropdown-item
                v-model="selectedFilter"
                :options="showFilters"
                get-container="body"
                @change="changeFilter"
                disabled
              />
            </van-dropdown-menu>
          </div>
          <div class="sort-filter-drop">
            <van-dropdown-menu active-color="#aa341b" style="width: 100%">
              <van-dropdown-item
                v-model="sortOrder"
                :options="sortOrderList"
                get-container="body"
                @change="changeFn"
              />
            </van-dropdown-menu>
          </div>
        </div>
      </div>
      <!-- <div v-if="false" class="search-bar-list">
        <div class="search-filter j-center">
          <span class="f-quest" @click="showDescFn(2)">
            排序<font-awesome-icon
              class="question-icon"
              :icon="['fa', 'question-circle']"
            />：
          </span>
          <van-checkbox-group
            v-model="sortOrder"
            direction="horizontal"
            checked-color="#aa341b"
            @change="changeFn($event)"
          >
            <van-checkbox name="physician_name">默认</van-checkbox>
            <van-checkbox name="institution_name">按医院名</van-checkbox>
            <van-checkbox v-if="selectedProduct" name="physician_segment_sort"
              >按医生等级</van-checkbox
            >
          </van-checkbox-group>
        </div>
      </div> -->
      <div class="search-bar-list">
        <div
          class="search-filter j-center"
          style="background-color: #f2f5f9; padding-top: 15px"
        >
          <div class="hospital-count-div">
            <span class="hospital-count-item"
              >{{ $t('doctor_count') }}<span class="f-blod">{{ physician_count }}</span></span
            >
            <!-- <span class="hospital-count-item"
              >外部数据医生数：<span class="f-blod">{{
                ex_data_support_count
              }}</span></span
            > -->
            <span class="hospital-count-item"
              >{{ $t('hcp_list_wechat_doctor_count') }}<span class="f-blod">{{
                is_wechat_count
              }}</span></span
            >
          </div>
        </div>
      </div>
      <div
        style="background-color: #f2f5f9"
        class="index-list-wrapper custom"
        :class="{
          'no-list': list.length == 0,
          'index-list-wrapper-nosales': !isSales,
        }"
      >
        <van-list
          v-model="listLoading"
          :finished="finished"
          :immediate-check="false"
          :finished-text="$t('no_more_txt')"
          @load="onLoad"
        >
          <CardItem
            v-for="(item, $index) in list"
            :id="'ITEM' + $index"
            :ref="$index == 0 ? 'AIMREF' : ''"
            :key="item.product_id + '_' + item.physician_id + $index"
            :is-favorite="true"
            :gen-status="false"
            :show-draw="false"
            :item="item"
            :parting="item.result"
            :physician-segment="item.physician_segment"
            @refreshFn="pageFn"
            @clickItem="selectItem(item)"
          />
          <Nodata
            v-if="!list.length"
            :loading="loading"
            :empty-txt="$t('no_data')"
          />
        </van-list>
        <div style="height: 50px"></div>
      </div>
    </template>
    <popup
      v-if="showDescStatus"
      :title="searchDescTitle"
      @closeFn="showDescStatus = false"
    >
      <div class="box" style="max-height: 400px; overflow-y: auto">
        <div class="seg-type-desc box">
          <div class="seg-type-list">
            <p v-if="searchDescType === 'search'">
              <span class="td-value">{{ $t('search_desc_content') }}</span>
            </p>
            <template v-if="searchDescType === 'sort'">
              <p>
                <span class="td-title">{{ $t('hcp_list_default_sort') }}</span>
                <span class="td-value">{{ $t('hcp_list_default_sort_desc') }}</span>
              </p>
              <p>
                <span class="td-title">{{ $t('sort_by_hospital') }}</span>
                <span class="td-value">{{ $t('sort_by_hospital_desc') }}</span>
              </p>
              <p>
                <span class="td-title">{{ $t('sort_by_level') }}</span>
                <span class="td-value">{{ $t('sort_by_level_desc') }}</span>
              </p>
            </template>
          </div>
        </div>
      </div>
    </popup>
    <!-- filter popup -->
    <van-popup
      v-model="showFilterPopup"
      position="left"
      closeable
      style="width: 70%"
    >
      <div class="filter-popup">
        <van-form>
          <van-field
            v-model="filterParams.search_key"
            :label="$t('search_keyword')"
            :placeholder="$t('enter_keyword')"
          >
            <template #label>
              <div class="field-label">{{ $t('search_keyword') }}</div>
            </template>
          </van-field>
          <van-field :label="$t('hcp_list_is_target_doctor')">
            <template #label>
              <div class="field-label">{{ $t('hcp_list_is_target_doctor') }}</div>
            </template>
            <template #input>
              <van-checkbox-group v-model="filterParams.is_target">
                <van-checkbox
                  v-for="option in targetOptions"
                  :key="option.value"
                  :name="option.value"
                >
                  {{ option.text }}
                </van-checkbox>
              </van-checkbox-group>
            </template>
          </van-field>
          <van-field :label="$t('task_filter_product')">
            <template #label>
              <div class="field-label">{{ $t('task_filter_product') }}</div>
            </template>
            <template #input>
              <van-checkbox-group
                v-model="filterParams.product_ids"
              >
                <van-checkbox
                  v-for="option in productOptions"
                  :key="option.value"
                  :name="option.value"
                >
                  {{ option.text }}
                </van-checkbox>
              </van-checkbox-group>
            </template>
          </van-field>
          <van-field v-show="hcpSegmentOptionsComputed.length" :label="$t('hcp_list_segment')">
            <template #label>
              <div class="field-label">{{ $t('hcp_list_segment') }}</div>
            </template>
            <template #input>
              <van-checkbox-group v-model="filterParams.hcp_segments">
                <van-checkbox
                  v-for="option in hcpSegmentOptionsComputed"
                  :key="option.value"
                  :name="option.value"
                >
                  {{ option.text }}
                </van-checkbox>
              </van-checkbox-group>
            </template>
          </van-field>
          <van-field :label="$t('hcp_list_sales_class')">
            <template #label>
              <div class="field-label">{{ $t('hcp_list_sales_class') }}</div>
            </template>
            <template #input>
              <van-checkbox-group v-model="filterParams.hcp_classes">
                <van-checkbox
                  v-for="option in hcpClassOptions"
                  :key="option.value"
                  :name="option.value"
                >
                  {{ option.text }}
                </van-checkbox>
              </van-checkbox-group>
            </template>
          </van-field>
          <van-field :label="$t('is_wechat_bound')">
            <template #label>
              <div class="field-label">{{ $t('is_wechat_bound') }}</div>
            </template>
            <template #input>
              <van-checkbox-group v-model="filterParams.is_wechat">
                <van-checkbox
                  v-for="option in wechatOptions"
                  :key="option.value"
                  :name="option.value"
                >
                  {{ option.text }}
                </van-checkbox>
              </van-checkbox-group>
            </template>
          </van-field>
          <van-field :label="$t('is_consent_signed')">
            <template #label>
              <div class="field-label">{{ $t('is_consent_signed') }}</div>
            </template>
            <template #input>
              <van-checkbox-group v-model="filterParams.is_consent">
                <van-checkbox
                  v-for="option in consentOptions"
                  :key="option.value"
                  :name="option.value"
                >
                  {{ option.text }}
                </van-checkbox>
              </van-checkbox-group>
            </template>
          </van-field>
          <van-field>
            <template #input>
              <div
                style="
                  margin-top: 40px;
                  width: 100%;
                  display: flex;
                  justify-content: center;
                "
              >
                <van-button
                  @click="handleFilter"
                  round
                  type="info"
                  :disabled="searchDisable"
                  :loading="loading && resetDisable"
                  class="search-filter-button"
                  color="#aa341b"
                  style="height: 40px"
                  >{{ $t('confirm_txt') }}</van-button
                >
                <van-button
                  round
                  plain
                  type="info"
                  class="search-filter-button"
                  color="#aa341b"
                  :disabled="resetDisable"
                  :loading="loading && searchDisable"
                  @click="resetFilter"
                  style="height: 40px; margin-left: 20px"
                >
                  {{ $t('reset') }}
                </van-button>
              </div>
            </template>
          </van-field>
        </van-form>
      </div>
    </van-popup>
  </div>
</template>

<script>
import * as py from '@/api/Physicians';
import popup from '@/views/layout/popup';
import swipeBack from '@/views/layout/swipeBack';
import {
  List,
  Search,
  DropdownMenu,
  DropdownItem,
  Button,
  Collapse,
  CollapseItem,
  RadioGroup,
  Radio,
  Popup,
  Form,
  Field,
  Picker,
  Checkbox,
  CheckboxGroup,
} from 'vant';
import {
  getFirstUpperChar,
  getLocalStorage,
  setLocalStorage,
  debounce,
} from '@/utils/index';
import _ from 'underscore';
// import followBscMIxin from "@/mixins/followBscMIxin";
import refreshUserID from '@/mixins/refreshUserID';
import Nodata from '@/components/Nodata';
import CardItem from '@/views/hcp/components/CardItem';
import SummaryChart from '@/components/SummaryChart';
import CommonHeader from '@/components/CommonHeader';
import kvpKeyMixin from '@/mixins/kvpKey';

export default {
  components: {
    CardItem,
    popup,
    swipeBack,
    Nodata,
    vanList: List,
    vanSearch: Search,
    vanDropdownMenu: DropdownMenu,
    vanDropdownItem: DropdownItem,
    vanButton: Button,
    vanCollapse: Collapse,
    vanCollapseItem: CollapseItem,
    vanRadioGroup: RadioGroup,
    vanRadio: Radio,
    vanPopup: Popup,
    vanForm: Form,
    vanField: Field,
    vanPicker: Picker,
    vanCheckbox: Checkbox,
    vanCheckboxGroup: CheckboxGroup,
    // CommonHeader,
  },
  mixins: [kvpKeyMixin('ta')],
  mixins: [refreshUserID],
  data() {
    return {
      pageName: 'doctorList',
      sortOrder: 'physician_name',
      activeTxt: 'other',
      isHcpHeader: 0,
      keyword: '',
      loading: false,
      singerData: [], // 结构数据
      initList: [], // 初始数据
      list: [],
      listLoading: false,
      finished: false,
      pageNum: 1,
      // searchKey: '',
      isSearch: false,
      loadingTxt: this.$t('loading_txt'),
      physician_count: 0,
      ex_data_support_count: 0,
      is_wechat_count: 0,
      userProducts: [],
      showFilters: [{text: this.$t('hcp_list_all_customers'), value: ''}],
      filterData: [],
      selectedFilter: '',
      filterProduct: '', // The product of the selected filter
      filterQuery: '', // The odata filter query of the selected filter
      showProduct: [{text: this.$t('all_products'), value: ''}],
      searchDisable: false,
      resetDisable: false,
      summaryData: [],
      activeNames: '',
      isSales: null,
      loadUrl: null,
      showDescStatus: false,
      isMr: false,
      searchDescType: 'search',
      title: '', // 医生列表
      sortOrderList: [{text: this.$t('hcp_list_default_sort_option'), value: 'physician_name'}],
      showFilterPopup: false,
      product_ids: [],
      hcp_classes: [],
      hcp_segments: [],
      is_target: ['true'],
      is_wechat: [],
      is_consent: [],
      search_key: '',
      productOptions: [
        {text: 'Azilect', value: 'Azilect_000001'},
        {text: 'Brintellix', value: 'Brintellix_000001'}, 
        {text: 'Ebixa', value: 'Ebixa_000001'},
        {text: 'Lexapro', value: 'Lexapro_000001'},
        // {text: 'Vyepti', value: 'Vyepti_000001'},
      ],
      hcpClassOptions: [
        {text: 'A', value: 'A'},
        {text: 'B', value: 'B'},
        {text: 'C', value: 'C'},
        // ...其他分级选项
      ],
      filterParams: {
        is_target: ['true']
      },
    };
  },
  computed: {
    searchDescTitle() {
      return this.searchDescType === 'search'
        ? this.$t('search_desc_title')
        : this.$t('sort_desc_title');
    },
    showHeaderBar() {
      if (this.$route.name != 'listHome') {
        return false;
      } else if (this.$route.name != 'doctorListHome') {
        return false;
      } else {
        return true;
      }
    },
    filterPrompt() {
      let prompts = [];
      if (this.filterParams.is_target && this.filterParams.is_target.length) {
        if (this.filterParams.is_target.indexOf('true') >= 0)
          prompts.push(this.$t('hcp_list_target'));
        if (this.filterParams.is_target.indexOf('false') >= 0)
          prompts.push(this.$t('hcp_list_non_target'));
      }
      if (this.filterParams.product_ids && this.filterParams.product_ids.length) {
        let productInitials = '';
        this.filterParams.product_ids.forEach((productId) => {
          productInitials += productId.charAt(0);
        });
        if (productInitials) {
          prompts.push(productInitials);
        }
      }
      if (this.filterParams.hcp_classes && this.filterParams.hcp_classes.length) {
        let segmentInitials = '';
        this.filterParams.hcp_classes.forEach((segment) => {
          segmentInitials += segment.charAt(0);
        });
        if (segmentInitials) {
          prompts.push(segmentInitials + this.$t('hcp_list_class_suffix'));
        }
      }
      if (this.filterParams.is_wechat && this.filterParams.is_wechat.length) {
        if (this.filterParams.is_wechat.indexOf('true') >= 0)
          prompts.push(this.$t('hcp_list_bound'));
        if (this.filterParams.is_wechat.indexOf('false') >= 0)
          prompts.push(this.$t('hcp_list_unbound'));
      }
      if (this.filterParams.is_consent && this.filterParams.is_consent.length) {
        if (this.filterParams.is_consent.indexOf('true') >= 0)
          prompts.push(this.$t('hcp_list_consented'));
        if (this.filterParams.is_consent.indexOf('false') >= 0)
          prompts.push(this.$t('hcp_list_not_consented'));
      }
      return prompts.length
        ? this.$t('hcp_list_filter_prompt_prefix') + prompts.join(this.$t('hcp_list_filter_prompt_separator'))
        : '';
    },
    hcpSegmentOptionsComputed() {
      // Brintellix_000001 为 Brintellix 的 product_id
      if (
        this.filterParams.product_ids &&
        this.filterParams.product_ids.includes('Brintellix_000001')
      ) {
        return [
          { text: this.$t('hcp_list_segment_waiter'), value: '观望者' },
          { text: this.$t('hcp_list_segment_trier'), value: '尝试者' },
          { text: this.$t('hcp_list_segment_advocate'), value: '倡导者' }
        ];
      }
      return [];
    },
    targetOptions() {
      return [
        {text: this.$t('yes'), value: 'true'},
        {text: this.$t('no'), value: 'false'},
      ];
    },
    wechatOptions() {
      return [
        {text: this.$t('yes'), value: 'true'},
        {text: this.$t('no'), value: 'false'},
      ];
    },
    consentOptions() {
      return [
        {text: this.$t('yes'), value: 'true'},
        {text: this.$t('no'), value: 'false'},
      ];
    },
  },
  created() {
    if (this.$route.query.department_name) {
      this.title = this.$route.query.department_name;
    }
    if (this.$route.query.institution_name) {
      this.title = this.title
        ? this.title + ' - ' + this.$route.query.institution_name
        : this.$route.query.institution_name;
    }
    if (
      getLocalStorage('territory_type') &&
      getLocalStorage('territory_type') === 'MR'
    ) {
      this.isMr = true;
    }
    // Restore filter and sort order from localStorage or other storage
    this.keyword = getLocalStorage('keyword') || this.keyword;
    this.selectedFilter =
      getLocalStorage('selectedFilter') || this.selectedFilter;
    this.sortOrder = getLocalStorage('sortOrder') || this.sortOrder;

    this.loading = true;
    this.getUserId();
    // this.initPage(getLocalStorage("user_id"));

    // 如果 this.filterParams 有就赋值
    if (getLocalStorage('filterParams')) {
      const filterParams = JSON.parse(getLocalStorage('filterParams'));
      if (Array.isArray(filterParams.is_target)) {
        this.filterParams = filterParams;
      }
    }
  },
  watch: {
    keyword(newVal) {
      setLocalStorage('keyword', newVal);
    },
    selectedFilter(newVal) {
      setLocalStorage('selectedFilter', newVal);
    },
    sortOrder(newVal) {
      setLocalStorage('sortOrder', newVal);
    },
    'filterParams.product_ids'(newVal) {
      if (!newVal.includes('Brintellix_000001')) {
        this.filterParams.hcp_segments = [];
      }
    },
  },
  mounted() {},
  methods: {
    getSortOrderOptions() {
      return [
        {text: this.$t('hcp_list_default_sort_option'), value: 'physician_name'},
        {text: this.$t('hcp_list_sort_by_hospital_option'), value: 'institution_name'},
      ];
    },
    backFn() {
      if (this.$route.query.routeTxt === 'department') {
        // 返回科室
        this.$router.push({
          path: '/hcp/department',
          query: {
            user_id: getLocalStorage('user_id'),
            institution_id: this.$route.query.institution_id,
            tab_state: this.$route.query.tab_state,
            institution_name: this.$route.query.institution_name,
          },
        });
      } else {
        // 返回首页  (this.$route.query.routeTxt === 'home')
        this.$router.push({
          path: '/hcp/home',
          query: {
            user_id: getLocalStorage('user_id_key'),
            tab_state: this.$route.query.tab_state,
          },
        });
      }
    },
    showDescFn(status) {
      this.searchDescType = status === 1 ? 'search' : 'sort';
      this.showDescStatus = true;
    },
    closeWXWindow() {
      window.history.pushState(null, null, document.URL);
    },
    initPage(userId) {
      this.loading = true;
      if (this.isSales || this.isSales === 0) {
        this.list = [];
        this.getTerritorieInfo(userId);
        this.getShowProduct(userId);
      } else {
        this.getIsSales(userId);
      }
    },
    getShowProduct(userId) {
      const loadPage = () => {
        this.pageFn(true);
      };

      py.getUserProduct(userId).then((prodRes) => {
        if (prodRes && prodRes.value && prodRes.value.length) {
          this.userProducts = prodRes.value;
          py.getPhysicianFilters().then((filterRes) => {
            if (filterRes && filterRes.value) {
              this.filterData = filterRes.value;
              this.showFilters = [];
              filterRes.value.forEach((item) => {
                this.showFilters.push({
                  text: item.view_name,
                  value: item.cnf_physician_view_id,
                });
              });
              this.selectedFilter =
                this.selectedFilter || this.showFilters[0].value;
            }
            loadPage();
          }).catch(() => {
            loadPage();
          });
          // this.showProduct = [{text: '全部产品', value: ''}];
          // res.value.map((item) => {
          //   this.showProduct.push({
          //     text: item.product_name,
          //     value: item.product_id,
          //   });
          // });
          // if (this.isSales) {
          //   res.value.map((item) => {
          //     this.showProduct.push({
          //       text: '仅 ' + item.product_name,
          //       value: 'only_' + item.product_id,
          //     });
          //   });
          // }
        } else {
          loadPage();
        }
      }).catch(() => {
        loadPage();
      });
    },
    // changeProduct() {
    //   this.selectedParting = '';
    //   if (!this.selectedProduct) {
    //     this.sortOrder = 'physician_name';
    //   }
    //   this.getShowPating();
    //   this.searchDoctor();
    // },
    changeFilter() {
      if (!this.selectedFilter) {
        this.sortOrder = 'physician_name';
      }
      this.searchDoctor();
    },
    getTerritorieInfo(userId) {
      this.getTerritoryTypingKpi(getLocalStorage('territory_id'));
    },
    sortNameFn(arr) {
      const listDataMap = _.groupBy(arr, (ele) => {
        ele.name = getFirstUpperChar(ele.physician_name);
        return ele.name;
      });
      let mapArr = [];
      for (let key in listDataMap) {
        mapArr.push({
          name: key,
          items: listDataMap[key],
        });
      }
      const sortArr = _.sortBy(mapArr, 'name');
      let list = [];
      sortArr.forEach((ele) => {
        list = list.concat(ele.items);
      });
      return list;
    },
    dealListData(arr) {
      let concatArr = [];
      // if (this.isSearch) {
      //   // 搜索
      //   concatArr = arr;
      // } else {
      //   concatArr = this.list.concat(arr);
      // }
      let topArr = [];
      let noTopArr = [];
      arr.forEach((item) => {
        if (item.is_top) {
          topArr.push(item);
        } else {
          noTopArr.push(item);
        }
      });
      // 置顶数据
      const TopData = this.sortNameFn(topArr); // .sortBy(mapArr, 'name');
      // 未置顶数据
      const noTopDataOld = this.sortNameFn(noTopArr); // .sortBy(mapArr, 'name');
      const noTopData = noTopDataOld.sort((a, b) => {
        return a.name - b.name;
      });
      // this.list = [];
      const list = TopData.concat(noTopData);
      this.list = list;
      if (!this.isSearch) {
        this.initList = list;
      }
      this.loading = false;
    },
    // isSearch true 点击搜索时触发查询数量
    pageFn(isSearch) {
      this.filterData.forEach((item) => {
        if (item.cnf_physician_view_id === this.selectedFilter) {
          this.filterQuery = item.odata_query;
          this.selectedProduct = item.product_id;
        }
      });
      const filterOptions = [
        ...this.getSortOrderOptions(),
        // {text: '按医生等级排序', value: 'physician_segment_sort'},
      ];
      if (this.selectedProduct) {
        this.sortOrderList = filterOptions;
      } else {
        this.sortOrderList = filterOptions.filter(
          (option) => option.value !== 'physician_segment_sort',
        );
        if (this.sortOrder === 'physician_segment_sort') {
          this.sortOrder = 'physician_name';
        }
      }

      let data = {
        user_id: getLocalStorage('user_id'),
        pageNum: this.pageNum,
        pageSize: 20,
        physician_name: this.keyword,
        product_id: this.selectedProduct,
        result: this.selectedParting,
        institution_id: this.$route.query.institution_id,
        department_name: this.$route.query.department_name,
        clickSearch: isSearch,
        filterQuery: this.filterQuery,
      };
      let newData = {
        user_id: getLocalStorage('user_id'),
        page_index: this.pageNum,
        page_size: 20,
        ...this.filterParams,
      };
      if (
        data.pageNum - 1 === 0 ||
        (data.pageNum - 1) * data.pageSize < this.physician_count
      ) {
        this.loading = true;
        if (true || this.isSales) {
          if (this.selectedProduct) {
            py.getProductPhysicianList(data, this.sortOrder)
              .then((res) => {
                this.loadList(res, isSearch);
              })
              .catch((e) => {
                this.claerData();
              });
          } else {
            py.newGetPhysicianList(newData, this.sortOrder)
              .then((res) => {
                this.newLoadList(res, isSearch);
              })
              .catch((e) => {
                this.claerData();
              });
          }
        // } else {
        //   if (this.selectedProduct) {
        //     py.getManagementProductPhysicianList(data, this.sortOrder)
        //       .then((res) => {
        //         this.loadList(res, isSearch);
        //       })
        //       .catch((e) => {
        //         this.claerData();
        //       });
        //   } else {
        //     py.getManagementPhysicianList(data, this.sortOrder)
        //       .then((res) => {
        //         this.loadList(res, isSearch);
        //       })
        //       .catch((e) => {
        //         this.claerData();
        //       });
        //   }
        }
      } else {
        this.finished = true;
        this.listLoading = false;
      }
    },
    // debouncePageFn: _.debounce(function () {
    //   this.pageFn();
    // }, 500),
    loadList(aRes, isSearch) {
      let res = '';
      if (isSearch) {
        this.ex_data_support_count = aRes[0];
        this.is_wechat_count = aRes[1];
        res = aRes[2];
      } else {
        res = aRes;
      }
      if (res && res.value && res.value.length > 0) {
        if (res && res['@odata.count']) {
          this.physician_count = res['@odata.count'];
        }
        let resArr = res.value;
        if (res && resArr.length > 0) {
          resArr.forEach((ele) => {
            this.list.push(ele);
          });
        }
        this.initList = JSON.parse(JSON.stringify(this.list));
      } else {
        this.physician_count = 0;
        this.list = [];
        // this.loading = false;
        if (!this.isSearch) {
          // 非搜索
          this.finished = true;
        }
        this.isSearch = false;
      }
      this.loading = false;
      this.listLoading = false;
      this.searchDisable = false;
      this.resetDisable = false;
    },
    newLoadList(aRes, isSearch) {
      let res = '';
      res = aRes;
      if (res && res.data && res.data.length > 0) {
        if (res && res.data_count) {
          this.physician_count = res.data_count;
          this.is_wechat_count = res.wechat_data_count;
        }
        let resArr = res.data;
        if (res && resArr.length > 0) {
          resArr.forEach((ele) => {
            this.list.push(ele);
          });
        }
        this.initList = JSON.parse(JSON.stringify(this.list));
      } else {
        this.physician_count = 0;
        this.list = [];
        // this.loading = false;
        if (!this.isSearch) {
          // 非搜索
          this.finished = true;
        }
        this.isSearch = false;
      }
      this.loading = false;
      this.listLoading = false;
      this.searchDisable = false;
      this.resetDisable = false;
    },
    claerData() {
      this.listLoading = false;
      this.loading = false;
      this.isSearch = false;
      this.searchDisable = false;
      this.resetDisable = false;
      this.list = [];
    },

    onLoad() {
      if (!this.loading) {
        this.pageNum++;
        this.listLoading = true;
        this.pageFn();
      }
    },
    refreshFn() {
      this.list = [];
      this.pageFn();
    },
    selectItem(item) {
      this.$router.push({
        path: '/hcp/detail',
        query: {
          physician_id: item.physician_id,
          user_id: this.$route.query.user_id,
          // selectedLabel: 'persona',
          institution_id: this.$route.query.institution_id,
          institution_name: this.$route.query.institution_name,
          routeTxt: this.$route.query.routeTxt,
          tab_state: this.$route.query.tab_state,
          department_name: this.$route.query.department_name,
        },
      });
    },
    searchDoctor() {
      this.physician_count = 0;
      this.ex_data_support_count = 0;
      this.is_wechat_count = 0;
      this.list = [];
      this.pageNum = 1;
      this.finished = false;
      this.listLoading = false;
      this.isSearch = true;
      // this.filterParams.search_key = this.keyword;
      this.resetDisable = true;
      this.pageFn(true);
    },
    reset() {
      this.physician_count = 0;
      this.ex_data_support_count = 0;
      this.is_wechat_count = 0;
      this.sortOrder = 'physician_name';
      this.list = [];
      this.pageNum = 1;
      this.finished = false;
      this.keyword = '';
      // this.searchKey = '';
      this.selectedProduct = '';
      this.selectedParting = '';
      this.searchDisable = true;
      this.showProductParting = [{text: '全部分型', value: ''}];
      this.pageFn(true);
    },

    getCurrentProduct() {
      let currentProduct = '';
      if (this.selectedProduct.indexOf('Azilect') > -1) {
        currentProduct = 'Azilect';
      } else if (this.selectedProduct.indexOf('Brintellix') > -1) {
        currentProduct = 'Brintellix';
      } else if (this.selectedProduct.indexOf('Ebixa') > -1) {
        currentProduct = 'Ebixa';
      } else if (this.selectedProduct.indexOf('Lexapro') > -1) {
        currentProduct = 'Lexapro';
      }
      return currentProduct;
    },
    getTerritoryTypingKpi(territory_id) {
      py.getTerritoryTypingKpi(territory_id).then((res) => {
        if (res && res.value.length) {
          this.summaryData = [
            {
              label: '问卷已填写',
              value: res.value[0].ty_count,
            },
            {
              label: '问卷未填写',
              value: res.value[0].no_ty_count,
            },
            {
              label: '问卷完成度',
              value: (res.value[0].complate_rate * 100).toFixed(2) + '%',
            },
          ];
        }
      });
    },
    getIsSales(user_id) {
      const roleName = getLocalStorage('role_name');
      const salesRoles = ['销售', 'MR', 'DSM', 'RSM', 'RPM', 'MSL', 'GBA', 'GA']; // 定义销售角色
      if (salesRoles.includes(roleName)) {
        this.isSales = 1;
      } else {
        this.isSales = 0;
      }
      this.initPage(user_id);
    },
    changeFn($event) {
      this.searchDoctor();
    },
    handleFilter() {
      setLocalStorage('filterParams', JSON.stringify(this.filterParams));
      this.searchDoctor(); // 添加调用搜索方法
      this.showFilterPopup = false; // 关闭筛选弹窗
    },
    resetFilter() {
      this.filterParams = {
        is_target: ['true'],
      };
      setLocalStorage('filterParams', JSON.stringify(this.filterParams));
      this.searchDoctor(); // 添加调用搜索方法
      // setLocalStorage('filterParams', JSON.stringify(this.filterParams));
      // this.searchDoctor();
      // this.showFilterPopup = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/follow-list.scss';
.view-wrapper ::v-deep .cube-index-list-fixed,
.view-wrapper ::v-deep .cube-index-list-anchor {
  text-align: left;
}
.search-bar-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 12px;
  // padding-bottom: 10px;
  background: #fff;
  &.pd-btm0 {
    padding-bottom: 0;
  }
  .search-button {
    font-size: 14px;
    color: #333333;
    width: 50px;
    text-align: center;
    color: #aa341b;
    // position: absolute;
    // right: 20px;
    // top: 10px;
    i {
      font-size: 18px;
      color: #ccc;
    }
  }
}
.search-filter {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  background-color: #fff;
  align-items: center;
  padding: 0 20px 0 10px;
  &.j-center {
    justify-content: flex-start;
    padding: 0.166667rem 0 0.166667rem 18px;
  }
  .search-filter-drop {
    flex: 1;
    max-width: 70%;
    ::v-deep .van-dropdown-menu__item {
      justify-content: flex-start;
    }
  }
  .search-filter-reset {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 15%;
    font-size: 15px;
    font-family: Arial;
    font-weight: 400;
    color: #aa341b;
  }
  .search-filter-button {
    width: 1.8rem;
    height: 0.8rem;
    & + .search-filter-button {
      margin-left: 5px;
    }
  }
  .sort-filter-drop {
    flex: 1;
    max-width: 30%;
    ::v-deep .van-dropdown-menu__item {
      justify-content: flex-end;
    }
  }
}
.search-filter1 {
  white-space: nowrap;
}
::v-deep .van-dropdown-menu__bar {
  box-shadow: none;
}
.hcp-list-explain {
  font-size: 11px;
  background-color: #e0e6ed;
  padding: 15px;
  text-align: center;
}
.view-wrapper {
  width: 100%;
  height: 100%;
  // overflow-y: auto;
  // position: relative;
  .add-fav-explain {
    font-size: 14px;
    background-color: #e1f3da;
    padding: 15px 0;
    text-align: center;
  }
  .bac-be {
    height: 30px;
    background-color: #ebebee;
  }
}
.bac-be {
  height: 30px;
  background-color: #ebebee;
}
.show-more {
  font-size: 12px;
  text-align: center;
  color: #aa341b;
  margin-top: 40px;
  padding-bottom: 60px;
}
.radius-btn {
  border-radius: 20px;

  padding-left: 25px;
  padding-right: 25px;
}
.dimension-icon {
  margin-right: 4px;
}
.custom ::v-deep .name {
  display: flex;
  .name-w {
    // min-width: 60px;
  }
}
.no-list {
  ::v-deep .van-list__finished-text,
  ::v-deep .van-list__placeholder {
    display: none;
  }
}
.online-tab-box {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  .online-tab {
    width: 43%;
    padding: 10px;
    text-align: center;
    border-radius: 4px;
    background-color: #f0f0f0;
    &.active {
      color: #ffffff;
      background-color: #aa341b;
    }
  }
}
.hospital-box {
  .mg-to {
    margin-top: -5px;
  }
  img {
    max-width: 100%;
  }
}
.summary-container {
  display: flex;
  align-items: center;
  justify-content: space-around;

  .summary-item {
    flex: 1;
    padding: 15px 0 0;
    .label {
      font-size: 10px;
      color: #666;
      display: block;
    }
    .value {
      padding: 10px 0 5px;
      display: block;
      font-size: 28px;

      color: #ab351c;
      .v-bd {
        // border-bottom: 1px solid #ab351c;
        font-weight: initial;
      }
    }
  }
}
.van-cps ::v-deep .van-cell__title {
  font-size: 12px !important;
}
.van-cps ::v-deep .van-cell {
  padding-top: 0.166667rem;
  padding-bottom: 0.166667rem;
}
.hospital-count-div {
  display: flex;
  font-size: 12px;
  color: #aaa;
  .hospital-count-item + .hospital-count-item {
    margin-left: 20px;
  }
  .f-blod {
    // color: #aa341b;
    font-weight: bold;
  }
}
.f-quest {
  display: flex;
  &.f-quest-mg {
    margin: 0 5px;
  }
  .question-icon {
    color: #aa341b;
    margin-left: 3px;
    // margin-right: 5px;
  }
}
.filter-popup {
  min-height: calc(100vh - 40px);
  padding-top: 40px;
}
.van-checkbox,
.van-radio {
  margin-bottom: 4px;
}
::v-deep .van-radio__icon--checked .van-icon,
::v-deep .van-checkbox__icon--checked .van-icon {
  background-color: #aa341b;
  border-color: #aa341b;
}
.filter-popup ::v-deep .van-cell {
  display: block;
}
::v-deep .van-checkbox-group {
  margin-top: 10px;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}
::v-deep .van-radio-group {
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}
::v-deep .van-field__label {
  width: 100%;
}
::v-deep .van-dropdown-menu__item--disabled .van-dropdown-menu__title {
  color: #323233;
}
</style>
